// Google Ads / GA4 event helpers. Every call is a safe no-op when gtag is
// missing (ad blockers, prerender) — analytics must never break a user flow.

const ADS_ID = 'AW-17477321169';
const LEAD_CONVERSION = `${ADS_ID}/xJMUCPWBnt8cENGD641B`; // "Заявка на дзвінок"
const PHONE_CONVERSION = `${ADS_ID}/akPGCKvM-K0dENGD641B`; // "Клік по телефону (сайт)" — secondary action
const DEFAULT_LEAD_VALUE = 500; // UAH, ≈ one day of rental — used when no tool price is known

function gtagSafe(...args) {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag(...args);
    }
  } catch {
    // ignore analytics failures
  }
}

// Confirmed callback request. Phone goes to enhanced conversions (Google hashes it client-side).
export function trackLead({ value, phone } = {}) {
  const leadValue = Number(value) > 0 ? Number(value) : DEFAULT_LEAD_VALUE;
  if (phone && /^\+\d{10,15}$/.test(phone)) {
    gtagSafe('set', 'user_data', { phone_number: phone });
  }
  gtagSafe('event', 'conversion', { send_to: LEAD_CONVERSION, value: leadValue, currency: 'UAH' });
  gtagSafe('event', 'generate_lead', { value: leadValue, currency: 'UAH', method: 'callback_form' });
}

export function trackPhoneClick(placement) {
  if (PHONE_CONVERSION) {
    gtagSafe('event', 'conversion', { send_to: PHONE_CONVERSION, value: DEFAULT_LEAD_VALUE, currency: 'UAH' });
  }
  gtagSafe('event', 'phone_click', { placement: placement || 'unknown' });
}

export function trackReviewClick(placement) {
  gtagSafe('event', 'review_click', { placement: placement || 'unknown' });
}
